import { render, staticRenderFns } from "./MROwnership.vue?vue&type=template&id=27975cc6"
import script from "./MROwnership.vue?vue&type=script&lang=js"
export * from "./MROwnership.vue?vue&type=script&lang=js"
import style0 from "./MROwnership.vue?vue&type=style&index=0&id=27975cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports